import React, { createContext, useContext } from 'react';
import {
  BillingReactivationPollState,
  useBillingReactivationPoll,
} from '../hooks/useBillingReactivationPoll';

const defaultState: BillingReactivationPollState = {
  isReactivationReturn: false,
  isPolling: false,
  timedOut: false,
};

const BillingReactivationContext =
  createContext<BillingReactivationPollState>(defaultState);

export function BillingReactivationProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const value = useBillingReactivationPoll();
  return (
    <BillingReactivationContext.Provider value={value}>
      {children}
    </BillingReactivationContext.Provider>
  );
}

export function useBillingReactivation(): BillingReactivationPollState {
  return useContext(BillingReactivationContext);
}
